var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62492 11.6668V5.8335H9.62492V6.41683C10.0333 6.41683 10.4241 6.47516 10.7916 6.586V5.8335C10.7916 5.19183 10.2666 4.66683 9.62492 4.66683H9.04159V3.50016C9.04159 1.89016 7.73492 0.583496 6.12492 0.583496C4.51492 0.583496 3.20825 1.89016 3.20825 3.50016V4.66683H2.62492C1.98325 4.66683 1.45825 5.19183 1.45825 5.8335V11.6668C1.45825 12.3085 1.98325 12.8335 2.62492 12.8335H6.27659C6.03159 12.4835 5.83909 12.0868 5.71075 11.6668H2.62492ZM4.37492 3.50016C4.37492 2.53183 5.15659 1.75016 6.12492 1.75016C7.09325 1.75016 7.87492 2.53183 7.87492 3.50016V4.66683H4.37492V3.50016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62492 7.5835C8.01492 7.5835 6.70825 8.89016 6.70825 10.5002C6.70825 12.1102 8.01492 13.4168 9.62492 13.4168C11.2349 13.4168 12.5416 12.1102 12.5416 10.5002C12.5416 8.89016 11.2349 7.5835 9.62492 7.5835ZM10.5874 11.871L9.33325 10.6168V8.75016H9.91659V10.3777L10.9958 11.4568L10.5874 11.871Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClock);
export default __webpack_public_path__ + "static/media/lock_clock.1c8b81642c6942a15e2875363e8c8239.svg";
export { ForwardRef as ReactComponent };